module.exports = "/images/bus.png?fa77fbdb8a809e5ca753a52fd614b535";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/banner/bus.png
// module id = xRLK
// module chunks = 0